<template>
    <div>
        <v-overlay v-if="value && loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div
            v-show="false"
            v-viewer='{ "inline": false, "button": true, "navbar": true, "title": false, "toolbar": true, "tooltip": false, "movable": true, "zoomable": true, "rotatable": false, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }'
            ref="imageViewer"
            @hidden="imageViewerHidden"
            @hide="imageViewerHide"
            >
            <img v-for="(image, i) in previewImages" :key="i" :src="image" />
        </div>
    </div>
</template>

<script>
import assetUrl from '@/tools/assetUrl'

export default {
    props: [ 'value' ],

    data() {
        return {
            loading: true,
            previewImages: []
        }
    },

    watch: {
        value(to) {
            if (to) {
                this.loading = true
                this.getExplanationImages()
            }
        }
    },

    methods: {
        imageViewerHide() {
            this.loading = false
        },

        imageViewerHidden() {
            this.$emit('input', null)
            this.previewImages = []
            this.$refs.imageViewer.$viewer.index = 0
        },

        getExplanationImages() {
            this.loading = true

            this.$api.get(`history/${this.$route.params.history_hash}/${this.value}/explanation_image`)
                .then(response => {
                    this.previewImages = response.data.explanation_images.map(e => assetUrl(e))

                    setTimeout(() => this.$refs.imageViewer.$viewer.show(), 100)
                })
        }
    },
}
</script>
